var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSouthMounting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282,
    height: 76.9,
    viewBox: "0 0 282 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Samme",
    transform: "translate(10833 10085.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(-10821.4 -10082.138)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_676",
    "data-name": "Line 676",
    y2: 51.953,
    transform: "translate(42.276 20.886)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_677",
    "data-name": "Line 677",
    y2: 61.368,
    transform: "translate(74.556 11.471)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_676-2",
    "data-name": "Line 676",
    y2: 51.953,
    transform: "translate(182.154 20.886)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_677-2",
    "data-name": "Line 677",
    y2: 61.368,
    transform: "translate(214.434 11.471)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_669",
    "data-name": "Line 669",
    x2: 121.048,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 116.923, 0)",
    fill: "none",
    stroke: "#1d3c34",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_679",
    "data-name": "Line 679",
    x2: 121.048,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 256.8, 0)",
    fill: "none",
    stroke: "#1d3c34",
    strokeLinecap: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_681",
    "data-name": "Line 681",
    x1: 280,
    transform: "translate(-10832 -10009.299)",
    fill: "none",
    stroke: "#1d3c34",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthMounting);
export default __webpack_public_path__ + "static/media/south_mounting.a22e4a54c5b157b49c92fe4071aabbcc.svg";
export { ForwardRef as ReactComponent };